<template>
  <!-- 设置密码 -->
  <div class="retrieve-pw-container-bg">
    <PassWordStep :post="{ title: '找回密码' }"></PassWordStep>
  </div>
</template>

<script>
import PassWordStep from '@/components/PassWord/PassWordStep'

export default {
  name: 'PassWordRetrieve',
  components: { PassWordStep },
  data() {
    return {
      activeTab: 0,
      authorList: [],
      viewState: '',
      pageEnd: false,
      isPassWordLogin: true
    }
  },
  created() {},
  methods: {
    changeTab(index) {
      this.isPassWordLogin = index
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
.retrieve-pw-container-bg {
  background-color: #f0f0f0;
}
</style>
